module.exports = __webpack_public_path__ + "img/banner_formatos_tramites_externos-3.95bab39b.jpg";